<template>
  <div>
    <header>
			<div class="titlebar reverse" >
			   <div >
					<!-- <i class="el-icon-s-flag"></i> -->
					<i style="color:#ffffff;font-size:2.667vw;font-weight:bold;margin-left:1.333vw;">已答题（<span class="doneCount" style="margin-left:0;margin-top:-0.667vw;">0</span>/{{tolqust}}）</i>
			   </div>
			   <div style="color:#ffffff;font-size:2.667vw;font-weight:bold;line-height: normal; position: absolute;
    right: 1.6vw;">
					<i class="el-icon-time"></i><b class="alt-1" id="examtime">1:20</b>
			   </div>
			</div>
		</header>
		<article style="padding-bottom:5.867vw;padding-top:5.867vw;" id="leftTabBox">
		    <swiper :options="swiperOption" ref="qustSwiper" @slideChangeTransitionStart="onSlideChangeStart">
                    <swiper-slide class="test" style="margin-top:1.333vw;" v-for="(qust, index) in totaldetailexs" :key="index">
                    <div class="test_con">
                        <div class="item">
                        <div class="tit" v-if="qust.qustType!='复合题'">
                            <span>{{index+1}}.&nbsp;&nbsp;</span>
                            <span style="color:red">({{qust.qustType}})&nbsp;&nbsp;</span>
                            <input type="hidden" :id="index+1" :value='index+1'/>{{qust.title}}
                            <br/> <img v-if="qust.filepath" :src="`${global.remoteIp}/uploads/${qust.filepath}`" alt="" style="width: 100%;">
                        </div>
                         <div class="tit" v-else>
                            <span>{{index+1}}.&nbsp;&nbsp;</span>
                            <span style="color:red">({{qust.qustType}})&nbsp;&nbsp;</span>
                            <input type="hidden" :id="index+1" :value='index+1'/><p v-html="qust.title"></p>
                            
                        </div>
                        <div class="item_con">
                                <div class="answ">
                                <input type='hidden' :name='`QuestionA${index+1}`' class='answ' :id='`QuestionA${index+1}`' value='' />
                                <ul v-if="qust.foption"> 
                                    <li v-for="(option,indexex) in qust.foption.replace(/,jh,,jh,/g,',jh,').split(',jh,')"   :key="indexex" class='options' :id="`option_${index}_${indexex}`" @click="answer(qust,index,indexex,option)" :ids='index' :val='option.slice(0,1)'><i>{{option}}</i></li>
                                </ul>
                                 <ul v-else-if="qust.qustType=='判断题'">
                                    <li v-for="(option,indexex) in jugopts" :key="indexex" class='options' :id="`option_${index}_${indexex}`" @click="answer(qust,index,indexex,option)" :ids='index' :val='option'><i>{{option}}</i></li>
                                </ul>
                                <el-input
                                  v-else
                                  @input="forceUpdate"
                                  type="textarea"
                                  :autosize="{ minRows: 2, maxRows: 4}"
                                  placeholder="请填写答案"
                                  @blur="submitQust(qust,index)"
                                  v-model="arrfillanswer[`answer_${index}`]">
                                </el-input>
                                </div>
                        </div><!--item_con结束-->
                        </div><!--item结束-->
                    </div><!--test_con结束-->
                    </swiper-slide><!--test结束-->
                <!-- </div> -->
			</swiper>
			<input type="hidden" id="QuesDoing"></input>
        </article>
        <article >
			<div class="layAB" id="layAB">
			    <div class="serialNum">
					<div class="top">
						 <span class="mark">
						    <i class="noDo"></i><i>未答题</i>
							<i class="done"></i><i>已答题</i>
							<i class="doing"></i><i>当前答题</i>
							<img src="/static/images/back.png" width="5.6vw" id="closeLayAB"/>
						 </span>
					 </div>
					 <div class="con" >  <!--页码-->
					    <a href="#" v-for="index of totaldetailexs.length" :key="index" :class="`noDo ${index==1?'doing':''}`">{{index}}</a>
					    <font size="" color=""></font>
					 </div>
					 <div style="height:4vw;"></div>
					 <div class="clear"></div>
				</div>
				<div class="clear"></div>
			</div>          
		</article>
        <router-link class="back" to="/"></router-link> 
        <footer>
            <ul class="menubar animated fadeInUp delay3">
                <li class="tab" id="AnsSheet" style="color:#888;font-family:microsoft yahei;">
                    <i class="el-icon-postcard" style="font-size:4vw;"></i>
                    <label class="tab-label">答题板</label>
                </li>
                <li class="tab" id="SubmitExam" style="color:#888;font-family:microsoft yahei;">
                    <i class="el-icon-folder-checked" style="font-size:4vw;"></i>
                    <label class="tab-label">提交试卷</label>
                </li>
                <li class="tab" style="color:#888;font-family:microsoft yahei;" @click="nextQust()">
                    <i class="el-icon-edit" style="font-size:4vw;"></i>
                    <label class="tab-label">下一题</label>
                </li>
            </ul>
        </footer>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
    Message
} from 'element-ui';
import { MessageBox } from 'mint-ui';
import global from "../components/PublicComs/Common.vue";
export default {
  data() {
    return {
      paper: {},
      bigQusts: [],
      global,
      examtime: "",
      loadFinishNum: 0,
      tolqust: 0,
      totaldetailexs: [],
      swiperOption: {
        autoplay: false, //自动切换
        pagination: {
          el: ".swiper-pagination", //分页器
        },
      },
      record: {},
      jugopts:["正确","错误"],
      jugoptsw:["توغرا","خاتا"],
      arrfillanswer:{}
    };
  },

  components: {
    swiper,
    swiperSlide,
  },

  computed: {},

  mounted() {
    if (this.$route.params.id) {
      this.$axios
        .post(`/api/examRecords/startExam/${this.$route.params.id}`)
        .then((res) => {
          if (res.data) {
            this.paper = res.data.testPaper;
            if(this.paper.isViwen)this.jugopts = this.jugoptsw;
            this.bigQusts = res.data.testPaper.testPaperInfos;
            let examtime = this.paper.duration;
            this.record = res.data.record;
            let arrQustRecodes = res.data.data;
            let starttime = this.record.ctime;
            let ms = new Date() - new Date(starttime.replace(/[.-]/g, "/"));
            let starttime1 = parseInt(ms / 60000);
            let time = parseInt(examtime) - starttime1;
            time = `${parseInt(time / 60)}:${time % 60}:00`;
            $("#examtime").text(time);
            for (let index = 0; index < this.bigQusts.length; index++) {
              this.tolqust += this.bigQusts[index].selectedtopics.length;
            }
            for (let i = 0; i < this.bigQusts.length; i++) {
              this.bigQusts[i].ishow = false;
              this.$forceUpdate();
              this.$axios
                .get(
                  `/api/students/testPapers/${this.paper._id}/testPaperInfos/${this.bigQusts[i]._id}`
                )
                .then((res) => {
                  if (res.data) {
                    this.bigQusts[i].detailexs = res.data.questionInfo;
                    this.bigQusts[i].ishow = true;
                    if (!this.bigQusts[i].detailexs) {
                      this.bigQusts[i].detailexs = [];
                    }
                    for (
                      let j = 0;
                      j < this.bigQusts[i].detailexs.length;
                      j++
                    ) {
                      let qust = this.bigQusts[i].detailexs[j];
                      for (let k = 0; k < arrQustRecodes.length; k++) {
                        if (qust._id == arrQustRecodes[k].questionid) {
                          this.bigQusts[i].detailexs[j].record =
                            arrQustRecodes[k];
                          break;
                        }
                      }
                    }
                    this.$forceUpdate();
                    this.$nextTick(function () {
                      this.loadFinishNum++;
                    });
                  }
                });
            }
          }
        });
    }
  },

  methods: {
    getanswer(answer) {
      if (this.bigQust.type == "判断题") {
        if (answer == "1") {
          return "正确";
        } else {
          return "错误";
        }
      }
      return answer;
    },
    submitPaper() {
      this.$axios
        .post(`/api/examRecords/completeExam/${this.paper._id}`)
        .then((res) => {
          // Toast({
          //   message: '提交试卷成功'
          // });
          // this.$router.push("/");
          if(res.data.examAchieveMent)
          {
            MessageBox({
              title: '提交试卷成功',
              message: `试卷得分：${res.data.examAchieveMent.score}分`,
              showCancelButton: false
            }).then(() => {
              this.$router.push("/examrecord");
            });
          }else{
            MessageBox({
              title: '提交试卷成功',
              message:  '',
              showCancelButton: false
            }).then(() => {
              this.$router.push("/examrecord");
            });
          }
        });
    },
     submitQust(qust,index)
	  {
      var ids = index; //题目编号
      $(".doneCount").text($("a.done").length);
       $("#QuestionA" + ids).val(index);
      $("#TrueAns" + ids).text(index);
      //提交答案到服务器
      qust.record.useranswer = this.arrfillanswer[`answer_${index}`];
      this.$axios.post(`/api/examRecords/editExam/${qust.record._id}`,qust.record).then(res => {
			});
	  },
    answer(qust, i, j, option) {
      $("a.doing").addClass("done"); //答题板上的颜色
      var val = $(`#option_${i}_${j}`).attr("val"); //题目答案
      var ids = $(`#option_${i}_${j}`).attr("ids"); //题目编号
      let answer =""
      let alphabet=['A', 'B', 'C', 'D', 'E', 'F','G','H','J','K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R','S','T'];
      if (qust.qustType == "单选题") {
        let strclassnm = !qust.answer
          ? "cuowu"
          : qust.answer.indexOf(option.slice(0, 1)) > -1
          ? "zhengque"
          : "cuowu";
        $("li[ids=" + ids + "]").removeClass("zhengque");
        $("li[ids=" + ids + "]").removeClass("cuowu");
        $(`#option_${i}_${j}`).addClass(strclassnm);
        answer = option.slice(0, 1);
      } else if (qust.qustType == "多选题") {
        if (
          $(`#option_${i}_${j}`).hasClass("zhengque") ||
          $(`#option_${i}_${j}`).hasClass("cuowu")
        ) {
          $(`#option_${i}_${j}`).removeClass("zhengque");
          $(`#option_${i}_${j}`).removeClass("cuowu");
        } else {
          let strclassnm = !qust.answer
            ? "cuowu"
            : qust.answer.indexOf(option.slice(0, 1)) > -1
            ? "zhengque"
            : "cuowu";
          $(`#option_${i}_${j}`).addClass(strclassnm);
        }
        for(var k = 0; k <qust.foption.split(",jh,").length;k++)
        {
          if($(`#option_${i}_${k}`).hasClass("zhengque")||$(`#option_${i}_${k}`).hasClass("zhengque"))
          {
            answer+=alphabet[k]+","
          }
        }
        if(answer.slice(-1)==",")answer=answer.slice(0,answer.length-1);
      }else if(qust.qustType == "判断题") {
        let strclassnm = !qust.answer
          ? "cuowu"
          : qust.answer.indexOf(option) > -1
          ? "zhengque"
          : "cuowu";
        $("li[ids=" + ids + "]").removeClass("zhengque");
        $("li[ids=" + ids + "]").removeClass("cuowu");
        $(`#option_${i}_${j}`).addClass(strclassnm);
        answer = option;
      } 
      $(".doneCount").text($("a.done").length);
      $("#QuestionA" + ids).val(val);
      $("#TrueAns" + ids).text(val);
      //提交答案到服务器
      qust.record.useranswer = answer;
      this.$axios.post(`/api/examRecords/editExam/${qust.record._id}`,qust.record).then(res => {
			});

    },
    startanswer(qust, i, j, option) {
      $("a.doing").addClass("done"); //答题板上的颜色
      var val = $(`#option_${i}_${j}`).attr("val"); //题目答案
      var ids = $(`#option_${i}_${j}`).attr("ids"); //题目编号
      if (qust.qustType == "单选题") {
        let strclassnm = !qust.answer
          ? "cuowu"
          : qust.answer.indexOf(option.slice(0, 1)) > -1
          ? "zhengque"
          : "cuowu";
        $("li[ids=" + ids + "]").removeClass("zhengque");
        $("li[ids=" + ids + "]").removeClass("cuowu");
        $(`#option_${i}_${j}`).addClass(strclassnm);
      } else if (qust.qustType == "多选题") {
        if (
          $(`#option_${i}_${j}`).hasClass("zhengque") ||
          $(`#option_${i}_${j}`).hasClass("cuowu")
        ) {
          $(`#option_${i}_${j}`).removeClass("zhengque");
          $(`#option_${i}_${j}`).removeClass("cuowu");
        } else {
          let strclassnm = !qust.answer
            ? "cuowu"
            : qust.answer.indexOf(option.slice(0, 1)) > -1
            ? "zhengque"
            : "cuowu";
          $(`#option_${i}_${j}`).addClass(strclassnm);
        }
      }else if (qust.qustType == "判断题") {
        let strclassnm = !qust.answer
          ? "cuowu"
          : qust.answer.indexOf(option) > -1
          ? "zhengque"
          : "cuowu";
        $("li[ids=" + ids + "]").removeClass("zhengque");
        $("li[ids=" + ids + "]").removeClass("cuowu");
        $(`#option_${i}_${j}`).addClass(strclassnm);
      }else{
        this.arrfillanswer[`answer_${i}`] = option;
        this.$forceUpdate();
      }
      $(".doneCount").text($("a.done").length);
      $("#QuestionA" + ids).val(val);
      $("#TrueAns" + ids).text(val);
    },
    nextQust() {
      this.$refs.qustSwiper.swiper.slideNext();
    },
    onSlideChangeStart() {
      let i = this.$refs.qustSwiper.swiper.activeIndex;
      $("a.doing").removeClass("doing");
      $(".con a").eq(i).addClass("doing");
      i++;
      $("#QuesDoing").val($("#QuestionDoing" + i).val());
      $(".itemansw").css("display", "none");
    },
    forceUpdate() {
      this.$forceUpdate()
    },
  },
  watch: {
    loadFinishNum(newVal) {
      if (newVal == this.bigQusts.length) {
        for (let i = 0; i < this.bigQusts.length; i++) {
          for (let j = 0; j < this.bigQusts[i].detailexs.length; j++) {
            this.bigQusts[i].detailexs[j].qustType = this.bigQusts[i].type;
            this.totaldetailexs.push(this.bigQusts[i].detailexs[j]);
          }
        }

        $(function () {
          $("#AnsDis").click(function () {
            var questionid = $("#QuesDoing").val();
            if (questionid == "") {
              $("#QuesDoing").val($("#QuestionDoing1").val());
              questionid = $("#QuesDoing").val();
            }
            $("#QuesAnsw" + questionid).css("display", "block");
            if ($("#TrueAns" + questionid).text() == "") {
              $("#TrueAns" + questionid).text("无");
            }
          });
          //答案点击
          $("#closeLayAB").click(function () {
            $("#layAB").hide();
          });
          $("#collection").click(function () {
            mui.alert("添加收藏成功!", "提示", function () {});
          });
        });
        
        // pushHistory();
        window.addEventListener(
          "popstate",
          function (e) {
            pushHistory();
          },
          false
        );
        function pushHistory() {
          var state = {
            title: "title",
            url: "#",
          };
          window.history.pushState(state, "title", "#");
        }
        $(".con a").click(function () {
          index = $(this).text() - 1;
          s = $(".test").css("width");
          temp = parseInt(s.substring(0, s.length - 2));
          t = "-" + temp * index + "px";
          document.getElementById("bd12").style.webkitTransform =
            "translate(" + t + ",0px)  translateZ(0px)";
          $(".layAB").hide();
        });
        $("#AnsSheet").click(function () {
          $(".layAB").show();
        });
        /*倒计时*/
        window.jQuery(($) => {
          "use strict";
          $("time").countDown({
            with_separators: false,
          });
          $(".alt-1")
            .countDown({
              css_class: "countdown-alt-1",
            })
            .on("time.elapsing", () => {
              this.$confirm(
                "距离测评结束还有5分钟，请考生抓紧时间作答，时间到后会自动交卷！",
                "提示",
                {
                  confirmButtonText: "确定",
                  type: "warning",
                  center: true,
                }
              );
              this.fivetip = true;
            })
            .on("time.elapsed", () => {
              //自动交卷
              this.submitPaper();
            });
        });

        $("#SubmitExam").click( ()=> {
          if ($("a.done").length < this.totaldetailexs.length) {
            MessageBox.confirm('还有未答完的题目,确认要提交吗？?').then(action => {
              this.submitPaper();
            });
            // this.$confirm('还有未答完的题目,确认要提交吗？', '确认提交', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning',
            //   center: true
            // }).then(() => {
            //   this.submitPaper();
            // })
          } else {
            this.submitPaper();
          }
        });
        this.$nextTick(()=>{
          let alphabet=['A', 'B', 'C', 'D', 'E', 'F','G','H','J','K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R','S','T'];
          for(let i=0; i<this.totaldetailexs.length; i++) {
            if(this.totaldetailexs[i].record&&this.totaldetailexs[i].record.useranswer)
            {
              let answer = this.totaldetailexs[i].record.useranswer;
              $(".con a").eq(i).addClass("done");
              if(this.totaldetailexs[i].qustType=="单选题")
              {
                let index = alphabet.indexOf(answer);
                this.startanswer(this.totaldetailexs[i],i,index,answer)
              }else if(this.totaldetailexs[i].qustType=="多选题")
              {
                let arransw = answer.split(",");
                for(let h= 0; h < arransw.length; h++)
                {
                  let index = alphabet.indexOf(arransw[h]);
                  this.startanswer(this.totaldetailexs[i],i,index,arransw[h])
                }
              }else if(this.totaldetailexs[i].qustType=="判断题")
              {
                this.startanswer(this.totaldetailexs[i],i,this.jugopts.indexOf(answer),answer);
              }else
              {
                this.startanswer(this.totaldetailexs[i],i,0,answer);
              }
              
            }
          }
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/iconfont.scss";
@import "@/assets/css/mui.min.scss";
@import "@/assets/css/mui.scss";
@import "@/assets/css/phonestyle.scss";
.titlebar{
  min-height: 5.867vw;
  border-bottom: 0.133vw solid;
  box-sizing: border-box;
  height: 5.867vw;
}
.item .tit{
  font-size: 3vw;
  color: #363636;
  margin: 1.333vw 0px;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  min-height: 3vw;
  line-height: 3vw;
}
.item .tit span{
  font-size: 3vw;
}
.item_con li{
  font-size: 3vw;
    padding: 1.333vw 1.333vw 1.333vw 1.333vw;
    line-height: 3vw;
    cursor: pointer;
    background: none repeat scroll 0 0 #ede4f5;
    border: 0.133vw solid #cbaee3;
    margin-top: 2vw;
}
.menubar .tab{
  font-size: 3vw;
  padding-top: 1.5vw;
}
.tab{
  width: 100vw;
  height: 10vw;
  font-size:4vw;
}
.menubar .tab-label {
    display: block;
    height: 3vw;
    line-height: 3vw;
    font-size:3vw !important;
}
.serialNum .top{
  line-height: 3.2vw;
    height: 3.2vw;
    padding-bottom: 1.333vw;
    font-size: 2.133vw;
}
.serialNum .con a[data-v-ad308f76] {
    width: 5.333vw;
    height: 5.2vw;
    line-height: 5.2vw;
    margin: 0.667vw 1.6vw 0.667vw 0px;
    font-size: 2.267vw;
    text-align: center;
}
.mint-msgbox{
  height: 50vw;
  border-radius: 0.4vw;
    font-size: 2.133vw;
}
.titlebar.reverse{
  background-color: #F55C57;
  border-color: #F55C57;
}
</style>
